import {concatMap, of, tap} from 'rxjs';
import {Injectable} from '@angular/core';
import {AppConfigService} from '../../common/service/app-config.service';
import { HttpClient } from '@angular/common/http';
import {SlipService} from './slip-service';
import {AlertModalService} from '../../common/component/modal';
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/no-unused-vars */
@Injectable({
    providedIn: 'root'
})
export class ArcGisAuthService {
    title = 'FeaturesApplyDeleteService';
    authInfo: any;
    cadastreConfig: any;

    constructor(
        private appConfigService: AppConfigService,
        private http: HttpClient,
        private slipService: SlipService,
        private alertModalService: AlertModalService
    ) {}

    getTokenParam() {
        return '?token=' + this.authInfo.credentials[0].token;
    }
    authenticateArcGisUser() {
        if (this.cadastreConfig) {
            return of(null);
        }

        const url = this.appConfigService.settings.apiGatewayUrl + '/arcgis/auth/authenticateUser';
        return this.http.post<any>(url, {cache: false}).pipe(
            tap(arcGisAuthInfo => {
                this.authInfo = arcGisAuthInfo;
            }),
            concatMap(() => this.slipService.slipConfig()),
            tap(cadastreConfig => {
                this.cadastreConfig = cadastreConfig;
                if (!cadastreConfig.available) {
                    this.alertModalService.createAlertMessage(
                        this.appConfigService.getDesignProperties().DESIGN_SETTINGS.SLIP.SLIP_MESSAGE,
                        'Cancel',
                        'Warning',
                        'warning'
                    );
                }
            })
        );
    }
    //this.setupMapDefaultConfig();
}
